import { Box, Button, Typography } from '@mui/material';
import { MouseEventHandler } from 'react';
import { numberSeparator } from 'number-separator-js';
import Grid from '@mui/material/Unstable_Grid2';
import InvestorItem from '../item/InvestorItem';
import { IconSvg } from '../Icon';
import LoadingState from '../LoadingState';
import { PdpInfoDTO } from '@/types/models';
import { usePdpInvestors } from '@/api/hooks/usePdpInvestors';
import { IconButton } from '@/ui/kit/components/button';
interface InvestorListProps {
  data: PdpInfoDTO;
  onClose?: MouseEventHandler<HTMLButtonElement>;
}
const InvestorList = ({
  data,
  onClose
}: InvestorListProps) => {
  const texts = {
    preValue: 'کاربر',
    titleBTN: 'متوجه شدم'
  };
  const {
    data: investorsData,
    isLoading
  } = usePdpInvestors({
    planId: data.id
  });
  const item = {
    icon: <IconSvg component='Investors' width='40' height='40' />,
    title: 'تعداد سرمایه‌گذاران',
    subTitle: data ? `${numberSeparator({
      text: (+(data.investors || 0)).toString()
    })}` : '-',
    preValue: 'کاربر',
    color: 'primaryBrand.text',
    bgColor: 'primaryBrand.bg5',
    iconBgColor: 'primaryBrand.bg4'
  };
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'var(--spacing_m)',
    maxWidth: '456px',
    width: '100%',
    minWidth: {
      xs: 'unset',
      md: '456px'
    },
    margin: 'auto',
    py: 'var(--spacing_m_nudge)',
    px: 'var(--spacing_l)'
  }} data-sentry-element="Box" data-sentry-component="InvestorList" data-sentry-source-file="InvestorList.tsx">
      <InvestorItem icon={item.icon} title={item.title} subTitle={item.subTitle} preValue={item.preValue} color={item.color} bgColor={item.bgColor} iconBgColor={item.iconBgColor} data-sentry-element="InvestorItem" data-sentry-source-file="InvestorList.tsx" />
      {isLoading && <LoadingState />}
      <Grid container sx={{
      rowGap: 'var(--spacing_m)',
      overflowY: 'auto',
      maxHeight: '343px'
    }} data-sentry-element="Grid" data-sentry-source-file="InvestorList.tsx">
        {(investorsData || []).map(item => {
        return <Grid md={4} xs={6} key={'investment_investor_' + item.id} sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'var(--spacing_xs)'
        }}>
              <IconButton sx={{
            bgcolor: 'background.bg3',
            color: 'text.text2',
            borderRadius: 'var(--corner_radius_circular)',
            border: '1.5px solid ',
            borderColor: 'stroke.stroke3',
            width: 48,
            height: 48,
            cursor: {
              xs: 'pointer',
              md: 'default'
            }
          }}>
                <Typography variant='h6' component='p'>
                  {(item?.name || 'کاربر زیما')?.slice(0, 1)}
                </Typography>
              </IconButton>
              <Typography variant='captionRegular__Wallfund' color={'text.text2'} sx={{
            alignItems: 'center'
          }}>
                {item?.name || 'کاربر زیما'}
              </Typography>
            </Grid>;
      })}
      </Grid>
      <Box display='flex' data-sentry-element="Box" data-sentry-source-file="InvestorList.tsx">
        <Button variant='ghost' size='large' sx={{
        flex: 1,
        height: '48px',
        borderColor: 'primary'
      }} onClick={onClose} data-sentry-element="Button" data-sentry-source-file="InvestorList.tsx">
          {texts.titleBTN}
        </Button>
      </Box>
    </Box>;
};
export default InvestorList;